import React, { useState } from "react";
import { FileText, Info } from "lucide-react";

interface FicheItem {
  id: string;
  title: string;
  filename: string;
}

const FichesComponent: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // filename: "/assets/fiches/Fiche-information-Acide-hyaluronique.pdf",

  const informationSheets: FicheItem[] = [
    {
      id: "1",
      title: "Rhinoplastie",
      filename: "/assets/fiches/Fiche d’information Rhinoplastie.pdf",
    },
    {
      id: "2",
      title: "Génioplastie (mentoplastie)",
      filename:
        "/assets/fiches/Fiche d’information Génioplastie (mentoplastie).pdf",
    },
    {
      id: "3",
      title: "Otoplastie (oreilles décollées)",
      filename:
        "/assets/fiches/Fiche d’information Otoplastie (oreilles décollées).pdf",
    },
    {
      id: "4",
      title: "Blépharoplastie (paupières)",
      filename:
        "/assets/fiches/Fiche d’information Blépharoplastie (paupières).pdf",
    },
    {
      id: "5",
      title: "Lifting cervico-facial (lifting visage et cou)",
      filename:
        "/assets/fiches/Fiche d’information Lifting cervico-facial (lifting visage et cou).pdf",
    },
    {
      id: "6",
      title: "Lifting cervico-facial sous endoscopie",
      filename:
        "/assets/fiches/Fiche d’information Lifting cervico-facial sous endoscopie (lifting visage et cou).pdf",
    },
    {
      id: "7",
      title: "Lifting temporal",
      filename: "/assets/fiches/Fiche d’information Lifting temporal.pdf",
    },
    {
      id: "8",
      title: "Lifting frontal et temporal sous endoscopie",
      filename:
        "/assets/fiches/Fiche d’information Lifting frontal et temporal sous endoscopie.pdf",
    },
    {
      id: "9",
      title: "Lifting malaire concentrique (lifting des pommettes)",
      filename:
        "/assets/fiches/Fiche d’information Lifting malaire concentrique (lifting des pommettes ou lifting centrofacial).pdf",
    },
    {
      id: "10",
      title: "Calvitie (implants de cheveux)",
      filename:
        "/assets/fiches/Fiche d’information Calvitie (implants de cheveux).pdf",
    },
    {
      id: "11",
      title: "Toxine botulinique (Botox, rides)",
      filename:
        "/assets/fiches/Fiche d’information Toxine botulinique (Botox, rides).pdf",
    },
    {
      id: "12",
      title: "Acide hyaluronique",
      filename: "/assets/fiches/Fiche-information-Acide-hyaluronique.pdf",
    },
    {
      id: "13",
      title: "Dermabrasion",
      filename: "/assets/fiches/Fiche d’information Dermabrasion.pdf",
    },
    {
      id: "14",
      title: "Peelings",
      filename: "/assets/fiches/Fiche d’information Peelings.pdf",
    },
    {
      id: "15",
      title: "Produits de comblement",
      filename: "/assets/fiches/Fiche d’information Produits de comblement.pdf",
    },
    {
      id: "16",
      title: "Laser du visage",
      filename: "/assets/fiches/Fiche d’information Laser du visage.pdf",
    },
  ];

  // Sample data for required reading documents
  const requiredReadingDocs: FicheItem[] = [
    {
      id: "r1",
      title: "Prothèses mammaires (augmentation mammaire par implants)",
      filename: "/assets/avant-protheses/protheses-mammaires.pdf",
    },
    {
      id: "r2",
      title: "Lipofilling mammaire",
      filename: "/assets/avant-protheses/lipofilling-mammaire.pdf",
    },
    {
      id: "r3",
      title: "Hypertrophie mammaire (réduction mammaire)",
      filename: "/assets/avant-protheses/hypertrophie-mammaire.pdf",
    },
    {
      id: "r4",
      title: "Cure de ptose mammaire (seins tombants)",
      filename: "/assets/avant-protheses/cure-ptose.pdf",
    },
    {
      id: "r5",
      title: "Gynécomastie",
      filename: "/assets/avant-protheses/gynecomastie.pdf",
    },
    {
      id: "r6",
      title: "Lifting des cuisses",
      filename: "/assets/avant-protheses/lifting-cuisses.pdf",
    },
    {
      id: "r7",
      title: "Lifting des bras",
      filename: "/assets/avant-protheses/lifting-bras.pdf",
    },
    {
      id: "r8",
      title: "Plastie abdominale (abdominoplastie)",
      filename: "/assets/avant-protheses/plastie-abdominale.pdf",
    },
    {
      id: "r9",
      title: "Liposuccion (lipoaspiration)",
      filename: "/assets/avant-protheses/liposuccion.pdf",
    },
    {
      id: "r10",
      title: "Bodylift",
      filename: "/assets/avant-protheses/bodylift.pdf",
    },
    {
      id: "r11",
      title: "Prothèses de fesses (implants fessiers)",
      filename: "/assets/avant-protheses/protheses-fesses.pdf",
    },
    {
      id: "r12",
      title: "Nymphoplastie",
      filename: "/assets/avant-protheses/nymphoplastie.pdf",
    },
    {
      id: "r13",
      title: "Penoplastie d’allongement et d’élargissement",
      filename: "/assets/avant-protheses/penoplastie.pdf",
    },
    {
      id: "r14",
      title: "Reconstruction du sein par prothèse",
      filename: "/assets/avant-protheses/reconstruction-sein-prothese.pdf",
    },
    {
      id: "r15",
      title: "Reconstruction du sein par lambeau de grand dorsal",
      filename: "/assets/avant-protheses/reconstruction-sein-lambeau.pdf",
    },
    {
      id: "r16",
      title: "Reconstruction du sein par DIEP",
      filename: "/assets/avant-protheses/reconstruction-sein-diep.pdf",
    },
    {
      id: "r17",
      title: "Reconstruction du sein par lipofilling",
      filename: "/assets/avant-protheses/reconstruction-sein-lipofilling.pdf",
    },
    {
      id: "r18",
      title: "Reconstuction de l’aréole",
      filename: "/assets/avant-protheses/reconstruction-areole.pdf",
    },
  ];

  // Filter documents based on search term
  const filteredInfoSheets = informationSheets.filter((sheet) =>
    sheet.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredRequiredDocs = requiredReadingDocs.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle PDF click - you can implement your own logic here
  const handlePdfClick = (filename: string) => {
    // Example: Open PDF in new window
    console.log(`Opening PDF: ${filename}`);
    // Implement your PDF opening logic here
    window.open(`${filename}`, "_blank");
  };

  return (
    <div className="min-h-screen pb-24">
      {/* Header Section */}
      <div className="relative h-[60dvh]">
        <video
          autoPlay
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-cover"
        >
          <source src="/assets/videos/dr-youssef-intro.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-darkB opacity-30"></div>
        <div className="relative text-lightB flex flex-col items-center justify-center h-full text-white px-4">
          <h1 className="text-4xl font-bold mb-4 text-center">
            Documentation Patients
          </h1>
          <p className="text-xl text-center mb-8">
            Ressources et informations essentielles pour votre parcours
            chirurgical
          </p>

          {/* Search Input */}
          <div className="w-full text-center items-center mx-auto ">
            <input
              type="text"
              placeholder="Rechercher un document..."
              className=" py-3 w-1/3 placeholder-gray800 text-darkB px-12 rounded-full border-none shadow-lg focus:ring-2 focus:ring-blue-300 focus:outline-none"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Fiches d'informations Section */}
          <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center mb-6">
              <FileText className="w-6 h-6 text-[rgba(183,171,152,1)] mr-3" />
              <h2 className="text-2xl font-bold text-blue-800">
                Fiches d'informations
              </h2>
            </div>

            {filteredInfoSheets.length > 0 ? (
              <ul className="space-y-4">
                {filteredInfoSheets.map((sheet) => (
                  <li key={sheet.id}>
                    <button
                      onClick={() => handlePdfClick(sheet.filename)}
                      className="w-full text-left p-4 bg-gradient-to-br from-lightB to-gray200 rounded-lg flex items-center hover:scale-105 transition-transform duration-300 border-l-4 border-gray300"
                    >
                      <FileText className="w-5 h-5 text-[rgba(183,171,152,1)] mr-3 flex-shrink-0" />
                      <span className="font-medium text-darkB">
                        {sheet.title}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-center text-gray-500 py-8">
                Aucun document trouvé
              </p>
            )}
          </div>

          {/* À lire avant toute chirurgie Section */}
          <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center mb-6">
              <Info className="w-6 h-6 text-[rgba(183,171,152,1)] mr-3" />
              <h2 className="text-2xl font-bold text-blue-800">
                À lire avant toute chirurgie d'augmentation mammaire par implant
                ou prothèse
              </h2>
            </div>

            {filteredRequiredDocs.length > 0 ? (
              <ul className="space-y-4">
                {filteredRequiredDocs.map((doc) => (
                  <li key={doc.id}>
                    <button
                      onClick={() => handlePdfClick(doc.filename)}
                      className="w-full text-left p-4 bg-gradient-to-br from-lightB to-gray200 rounded-lg flex items-center hover:scale-105 transition-transform duration-300 border-l-4 border-gray300"
                    >
                      <FileText className="w-5 h-5 text-[rgba(183,171,152,1)] mr-3 flex-shrink-0" />
                      <span className="font-medium text-darkB">
                        {doc.title}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-center text-gray-500 py-8">
                Aucun document trouvé
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FichesComponent;
